export const MainServicesArray = [
  {
    label: 'BDSM',
  },
  {
    label: 'Wrestling',
  },
  {
    label: 'Sploshing',
  },
  {
    label: 'Findom',
  },
]